import React from 'react'
import type { MenuItem as MenuItemData } from 'api/api.types'
import logo from 'assets/logo/logo.svg'
import { Menu } from 'components/PageElements/Menu/Menu'
import { MenuItem } from 'components/PageElements/Menu/MenuItem'
import styles from './MobileMenu.module.css'

type MobileMenuProps = {
  topMenu: MenuItemData[],
  bottomMenu: MenuItemData[],
  onClose: () => void,
}

export const MobileMenu: React.FC<MobileMenuProps> = (props) => {
  const { topMenu, bottomMenu, onClose } = props
  return (
    <div className={styles.container}>
      <div className={styles.mainLogoContainer}>
        <img className={styles.mainLogo} src={logo} alt="icon" />
      </div>
      <Menu place={'header'}>
        {topMenu.map((el, index) => <MenuItem key={index} item={el} onClick={onClose} />)}
      </Menu>
      <Menu place={'extra'}>
        {bottomMenu.map((el, index) => <MenuItem key={index} item={el} onClick={onClose} />)}
      </Menu>
    </div>
  )
}
